<!--author: 胡枭 -->

<template>
  <div class="breadcrumb flex-align">
    <div class="back" @click="prevPage">返回上一页</div>
    <span class="segregation">|</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(route, index) in routerList"
        :key="`${route.title}-${index}`"
        :class="{
          'efficient-route': route.name,
          active: index === routerList.length - 1
        }"
        @click.native="jumpRouter(route, index)"
      >
        {{ route.title }}
      </el-breadcrumb-item>

      <!--      不需要隐藏时的项目展示-->
      <el-breadcrumb-item v-if="projectName" class="active">
        <span :title="projectName">{{ objectNameShow }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',

  props: {
    projectName: {
      type: String,
      default: ''
    },

    handleBackFun: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      hasHistory: false
    }
  },

  computed: {
    routerList() {
      return this.$route?.meta?.breadcrumb || []
    },

    // 最终展示的项目名称
    objectNameShow() {
      if (this.projectName && this.projectName.length <= 15) {
        return this.projectName
      }

      if (this.projectName && this.projectName.length > 15) {
        return this.projectName.slice(0, 15) + '...'
      }

      return this.projectName
    }
  },

  methods: {
    // 返回上一页
    prevPage() {
      if (window.history.length > 0) {
        if (this.handleBackFun) {
          this.handleBackFun()
        } else {
          this.$router.goBack()
        }
      } else {
        this.$router.push({ name: 'Homepage' })
      }
    },

    // 点击面包屑跳转
    jumpRouter(to, index) {
      if (to.name && index === this.routerList.length - 1) {
        this.$router.push({ name: to.name })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  color: #606266;

  //返回上一页样式
  .back {
    cursor: pointer;
    margin-right: pixel-to-rem($n: 16);
    white-space: nowrap;

    &:hover {
      @include text-bold;
      color: $primary-color;
    }
  }

  //竖线，分隔线
  .segregation {
    color: #c0c4cc;
    margin-right: pixel-to-rem($n: 16);
  }

  ::v-deep .el-breadcrumb__item {
    .el-breadcrumb__inner {
      font-weight: normal;
      color: $second-text-color;
    }

    &.efficient-route {
      cursor: pointer;
    }
    &.active {
      cursor: text !important;
    }

    &.active .el-breadcrumb__inner,
    &.efficient-route:hover .el-breadcrumb__inner {
      @include text-bold;
      color: $primary-color;
    }
  }
}
</style>
